export const BACKEND_URL = "http://localhost:4002"